import React, { useRef, useState } from "react";
// @ts-ignore
import { Picker } from "emoji-mart";
import styled from "styled-components";
import { colors } from "styles/color-tokens";

import { useClickOutside } from "libs/use-click-outside";
import { useOpenableState } from "libs/use-openable-state";
// @ts-ignore
import Smile from "../icons/smile.svg";
import { ActionButton } from "../v2/components/action-button";
import { TooltipWrapper } from "../../TooltipWrapper";

const HEIGHT_OF_EMOJI_SELECTOR = 426.64;
interface EmojiPickerProps {
  className?: string;
  onSelect: (value: any) => void;
  leftAlign: boolean;
  newDesign?: boolean;
}

export function EmojiPickerComponent(props: EmojiPickerProps) {
  const emojiModal = useOpenableState();
  const wrapperRef = useRef<HTMLDivElement>(null);
  useClickOutside(wrapperRef, emojiModal.close);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [bottomAligned, setBottomAligned] = useState(false);

  function onSelect(emoji: any) {
    props.onSelect(emoji);
  }

  const onMouseDown = () => {
    // check the distance between template button to bottom of the browser
    // if diff is less than height of the selector, bottom align it
    const bounding = buttonRef?.current?.getBoundingClientRect();
    if (
      (bounding?.bottom ?? 0) + HEIGHT_OF_EMOJI_SELECTOR >
      window.innerHeight + 50
    ) {
      // open invert
      setBottomAligned(true);
    }
    emojiModal.toggle();
  };

  return (
    <div ref={wrapperRef} className={props.className}>
      {props.newDesign ? (
        <TooltipWrapper
          tooltip={emojiModal.isOpened ? null : "Emojis"}
          placement={"top"}
        >
          <ActionButton
            onMouseDown={onMouseDown}
            ref={buttonRef}
            focused={emojiModal.isOpened}
          >
            <i className="fa-regular fa-face-smile  text-[12px]" />
          </ActionButton>
        </TooltipWrapper>
      ) : (
        <TemplateButton
          type="button"
          isOpen={emojiModal.isOpened}
          onMouseDown={onMouseDown}
          ref={buttonRef}
        >
          <Smile />
        </TemplateButton>
      )}

      {emojiModal.isOpened && (
        <Picker
          onClick={onSelect}
          sheetSize={32}
          title="Sked"
          {...(bottomAligned ? { style: { top: "unset", bottom: 40 } } : {})}
        />
      )}
    </div>
  );
}

const TemplateButton = styled.button<{ isOpen: boolean }>`
  width: 24px;
  min-width: 24px;
  height: 24px;
  padding: 0;
  appearance: none;
  border: none;
  box-shadow: 0 1px 4px ${colors.black}33;
  border: 1px solid
    ${(props) => (props.isOpen ? colors.primary500 : colors.primary100)};
  border-radius: 5px;
  background: ${(props) =>
    props.isOpen ? colors.primary500 : colors.primary50};
`;

export const EmojiPicker = styled(EmojiPickerComponent)`
  // emoji-mart package class name
  .emoji-mart {
    position: absolute;
    right: 0;
    top: 100%;
    z-index: 1000;
    ${({ leftAlign }) =>
      leftAlign &&
      `
      left: 0;
    `}
  }
`;
